<template>
  <MqResponsive target="xs-md">
    <div class="block text-center" style="width: 100%; margin-top: 60px">
      <el-carousel
        height="auto"
        autoplay
        style="width: 100%"
        indicator-position="none"
      >
        <el-carousel-item style="min-height: 113px; width: 100%">
          <img
            src="@/assets/chaojiao/banner1.jpg"
            alt=""
            class="banner-image"
            style="width: 100%"
          />
        </el-carousel-item>
      </el-carousel>
      <!--  -->
      <div style="min-width: 412px; color: #fff; margin-top: 20px">
        <div>
          <div style="font-size: 30px">精选文章</div>
          <span style="font-size: 12px">SEILECTED ARTICLES</span>
          <div class="line"></div>
        </div>
        <el-row
          :gutter="20"
          style="
            display: flex;
            justify-content: space-around;
            width: 100%;
            margin: 0;
          "
        >
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!-- 交易学院 -->
      <div style="min-width: 412px; color: #fff; margin-top: 20px">
        <div>
          <div style="font-size: 30px">交易学院</div>
          <span style="font-size: 12px">EXCHANGE SCHOOL</span>
          <div class="line"></div>
        </div>

        <el-row :gutter="10" style="margin-bottom: 20px">
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  基础知识
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                交易术语、流程等
              </div>
            </div>

            <img
              src="@/assets/技术分析.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
              margin: 0 0;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  技术分析
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                指标、图表形态讲解
              </div>
            </div>

            <img
              src="@/assets/基础知识.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 0px">
                  基本面分析
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                鷓玘蘺仞Ç喂济数据、政治事件影响
              </div>
            </div>

            <img
              src="@/assets/基础知识.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  交易策略
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                不同风格和风险偏好的策略分享
              </div>
            </div>

            <img
              src="@/assets/即时交易策略.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
              margin: 0 0;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  视频教学
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                实战演示和讲解
              </div>
            </div>

            <img
              src="@/assets/视频教学.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div text-align:center>期待更多...</div>
          </el-col>
        </el-row>
      </div>
      <!-- 交易大赛 -->
      <div
        style="
          min-width: 412px;
          color: #fff;
          margin-top: 20px;
          box-sizing: border-box;
        "
      >
        <div>
          <div style="font-size: 30px">精选文章</div>
          <span style="font-size: 12px">INTRODUCE</span>
          <div class="line"></div>
        </div>
        <el-row
          style="display: flex; flex-direction: column; align-items: center"
        >
          <el-col
            ><div class="grid-content ep-bg-purple" />
            <img style="width: 100%" src="@/assets/16.jpg" alt="Element logo" />
          </el-col>
          <el-col
            style="
              padding: 0 5px;
              text-align: left;
              background: #0f0f0f;
              line-height: 25px;
              height: auto;
              font-size: 12px;
              display: flex;
              flex-direction: column;
              align-items: center;
            "
            ><div class="grid-content ep-bg-purple-light" />

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周周奖是2020年冠融科技打造的专业外汇操盘手挑战赛事，将面向全球邀请外汇操盘手进行参赛，专为操盘手提供展示技术实力和学习交流的比赛平台。大赛秉承“发现优秀操盘手，合作互惠互利”的目的，坚持公平、公正、公开的原则，旨在深入挖掘可以实现稳定盈利的优秀操盘手，为代理商和资管公司选拔操盘手提供一条龙服务。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周周奖由冠融科技主办，联合全球各大知名外汇经纪商进行赞助和协办。比赛分为模拟挑战赛和实盘挑战赛，比赛长期进行，每场比赛的周期为一个自然周，每场比赛的比赛规则和奖励都有可能不一样，比赛结束后将会进行比赛排名的审核和奖励发放。
            </p>
            <el-button
              type="danger"
              size="large"
              style="
                padding: 12px 55px;
                background: #ce0203;
                border: #ce0203;
                width: 60%;
              "
              >查看详情 »</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!--  -->

      <div
        style="background: #0f0f0f; margin-top: 20px"
        v-for="(item, index) in 2"
        key="index"
      >
        <el-row
          style="
            text-align: left;
            background: #0f0f0f;
            line-height: 25px;
            display: flex;
            align-items: center;
            min-width: 412px;
            padding: 0 10px;
          "
        >
          <el-col :span="5"
            ><div class="grid-content ep-bg-purple" />
            <img
              style="width: 100%"
              src="@/assets/奖杯.png"
              alt="Element logo"
            />
          </el-col>
          <el-col
            style="
              text-align: left;
              line-height: 25px;
              color: #fff;
              font-size: 12px;
              width: 100%;
            "
          >
            <div style="display: flex; align-items: center">
              <div style="font-size: 18px">自由挑战赛(实盘)</div>
              <span
                style="
                  border: 1px solid #d10005;
                  color: #d10005;
                  font-size: 10px;
                  line-height: 16px;
                "
              >
                进行中
              </span>
            </div>
            <div
              style="border-bottom: 1px #4f4f4f solid; width: 100%; height: 1px"
            ></div>
            <p>
              比赛简介:自由实盘挑战赛由冠融科技主办，多家经纪商协办，比赛目的是通过实盘挑战赛方式为操盘手提供展示技术实力和学习
            </p>
            <p>
              周周奖是2020年冠融科技打造的专业外汇操盘手挑战赛事，将面向全球邀请外汇操盘手进行参赛，专为操盘手提供展示技术实力和学习交流的比赛平台。大赛秉承“发现优秀操盘手，合作互惠互利”的目的，坚持公平、公正、公开的原则，旨在深入挖掘可以实现稳定盈利的优秀操盘手，为代理商和资管公司选拔操盘手提供一条龙服务。
            </p>
            <p>
              周周奖由冠融科技主办，联合全球各大知名外汇经纪商进行赞助和协办。比赛分为模拟挑战赛和实盘挑战赛，比赛长期进行，每场比赛的周期为一个自然周，每场比赛的比赛规则和奖励都有可能不一样，比赛结束后将会进行比赛排名的审核和奖励发放。
            </p>
            <div
              style="
                float: right;
                display: flex;
                align-items: center;
                margin-top: 30px;
              "
            >
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <span style="font-size: 40px">633</span>
                <div>报名人数</div>
              </div>
              <el-button
                type="danger"
                size="large"
                style="
                  background: #ce0203;
                  border: #ce0203;
                  --el-button-size: 23px;
                  font-size: 12px;
                  margin-left: 10px;
                "
                >立即报名 »</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </MqResponsive>
  <!-- 以上手机端 -->
  <MqResponsive target="md+">
    <div class="block text-center" style="height: 500px; width: 100%">
      <el-carousel height="auto" autoplay>
        <el-carousel-item style="height: 500px">
          <img
            src="@/assets/chaojiao/线下业务.png"
            alt=""
            class="banner-image"
            style="width: 100%"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <div :style="{ height: bannerHeight + 'px' }">
      <img
        src="@/assets/chaojiao/合作赋能.png"
        alt=""
        class="banner-image"
        style="width: 100%; height: 100%"
      />
    </div> -->

    <div style="width: 1200px; margin: 70px auto; display: flex">
      <!-- <div>
        <div
          style="color: #fff; width: 200px; padding: 40px 0"
          class="business-col"
        >
          {{ $t("预约报名") }}
        </div>
        <el-tabs
          :tab-position="tabPosition"
          style="
            height: 500px;
            box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1),
              -5px -5px 5px rgba(0, 0, 0, 0.1);
          "
          class="demo-tabs"
          @tab-change="tabChange"
          v-model="activeName"
        >
          <el-tab-pane
            v-for="(item, index) in datas"
            :key="item.id"
            :name="index"
            :value="item.id"
          >
            <template #label>
              <span>{{ lang == "中文" ? item.name_cn : item.name_en }}</span>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div> -->

      <div>
        <div
          style="
            font-weight: 600;
            color: rgb(22, 40, 124);
            text-align: left;
            width: 200px;
          "
        >
          <div style="font-size: 18px; color: #eee">
            RESERVE AND <br />REGISTER
          </div>
          <sapn style="font-weight: 600; font-size: 16px">_________</sapn>
          <div style="font-size: 22px">{{ $t("预约报名") }}</div>
        </div>
        <div style="text-align: left">
          <div
            v-for="(item, index) in datas"
            :key="item.id"
            @click="handleClick(index, item.id)"
            style="margin: 10px 0; font-size: 20px"
          >
            <el-link :underline="false" :class="{ green: indexEnd == index }">{{
              lang == "中文" ? item.name_cn : item.name_en
            }}</el-link>
          </div>
        </div>
      </div>

      <div
        style="
          width: 1000px;
          text-align: left;
          display: flex;
          flex-direction: column;
          padding: 0 20px 20px;
        "
      >
        <!-- <div style="display: flex; justify-content: space-between">
          <div
            style="
              font-size: 20px;
              color: #333;
              padding-right: 8px;
              margin-bottom: 10px;
            "
          >
            {{ $t("预约报名") }}
            <span style="color: #515050; font-size: 12px"
              >/ {{ $t("活动分类") }}</span
            >
          </div>
          <div
            style="
              color: #666;
              font-size: 14px;
              display: flex;
              align-items: center;
              line-height: 5px;
            "
          >
            <el-icon style="margin-right: 5px" color="rgb(33, 52, 133)"
              ><House
            /></el-icon>
            {{ $t("您当前所在位置") }}：<el-link :underline="false"
              >{{ $t("首页") }} >
            </el-link>
            <el-link :underline="false"
              >&nbsp;{{ $t("预约报名") }} > &nbsp;</el-link
            >
            {{ $t("详情") }}
          </div>
        </div> -->
        <div v-if="activityList.length > 0">
          <div
            v-for="(item, index) in activityList"
            :key="index"
            v-if="!contentHtml"
            @click="detailsBtn(item.id, 'getActivityDetail')"
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div>
                <el-link
                  :underline="false"
                  style="
                    font-weight: bold;
                    line-height: 30px;
                    font-size: 16px;
                    color: #666;
                  "
                  >{{ lang == "中文" ? item.name_cn : item.name_en }}</el-link
                >
              </div>
              <div
                style="
                  color: #999;
                  font-size: 10px;
                  display: flex;
                  align-items: center;
                "
              >
                <el-icon style="margin-right: 5px"><Clock /></el-icon>发布：{{
                  item.created_at
                }}
              </div>
            </div>
            <div style="line-height: 25px; font-size: 12px">
              <el-link :underline="false">{{
                lang == "中文" ? item.notes_cn : item.notes_en
              }}</el-link>
            </div>
            <el-divider content-position="right"></el-divider>
          </div>
          <!-- <div v-else>
            <el-button
              style="
                padding: 8px 80px;
                background: rgb(33, 52, 133);
                color: #fff;
                border: none;
              "
              @click="dialogFormVisible = true"
              >立即报名</el-button
            >
            <div v-html="contentHtml"></div>
          </div> -->
        </div>
        <el-empty style="margin: 0 auto" v-else description="" />
      </div>
    </div>

    <div
      style="
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1),
          -5px -5px 5px rgba(0, 0, 0, 0.1);
        padding: 30px 50px;
        box-sizing: border-box;
        color: #16287c;
      "
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 12px;
        "
      >
        <img src="@/assets/chaojiao/业务组.png" style="margin-bottom: 10px" />
        <span>{{ $t("我们的主营业务") }}</span>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 12px;
        "
      >
        <img src="@/assets/chaojiao/愿景.png" style="margin-bottom: 10px" />
        <span>{{ $t("我们的愿景") }}</span>
      </div>
    </div>

    <el-dialog v-model="dialogFormVisible" title="报名" width="500">
      <el-form :model="form">
        <el-form-item label="报名人员姓名" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="报名人员手机" :label-width="formLabelWidth">
          <el-input v-model="form.phone" autocomplete="off" />
        </el-form-item>
        <el-form-item label="报名人员邮箱" :label-width="formLabelWidth">
          <el-input v-model="form.email" autocomplete="off" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="signUp"> 确认报名 </el-button>
        </div>
      </template>
    </el-dialog>
  </MqResponsive>
  <div><Footer /></div>
</template>

<script setup>
import Footer from "../Footer";
import { reactive, ref } from "vue";
import MyServerHttp from "../../plugins/http.js";
import Server from "../../plugins/server.js";
import apiServe from "../../plugins/api.js";
import { useRouter } from "vue-router";

const indexEnd = ref(0);

//banner
const bannerHeight = ref(500); // 默认高度
const handleResize = () => {
  if (window.innerWidth < 768) {
    bannerHeight.value = 200; // 小屏幕高度
  } else if (window.innerWidth < 1024) {
    bannerHeight.value = 300; // 中等屏幕高度
  } else {
    bannerHeight.value = 500; // 大屏幕高度
  }
};
//报名弹框
const dialogFormVisible = ref(false);
const formLabelWidth = "140px";
const form = reactive({
  activity_id: "",
  name: "",
  phone: "",
  email: "",
});
const signUp = async () => {
  try {
    const response = await MyServerHttp.post(apiServe.register, form);
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
const contentHtml = ref("");
const contentId = ref("");
const router = useRouter();

const detailsBtn = (id, type) => {
  console.log();
  router.push({ path: "/Details", query: { id, type } });
};

let lang = ref("");
if (!localStorage.getItem("lang")) {
  lang = "中文";
} else {
  lang = localStorage.getItem("lang");
}
const activeName = ref(0);
const datas = ref([]);
const getList = async () => {
  try {
    const response = await MyServerHttp.post(apiServe.activityCategoryList);
    datas.value = response.data.datas.list.data;
    getActivityList(response.data.datas.list.data[0].id);
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
getList();

const handleTabsEdit = (tab, event) => {
  // console.log("-------------------", tab, event);
};

const tabPosition = ref("left");
// const activeName = ref("1");
// let name = ref("股票课程/FStockcourse");
// let img = require("@/assets/chaojiao/预约报名01.png");

const handleClick = (index, id) => {
  indexEnd.value = index;
  getActivityList(id);
};
const activityList = ref([]);
const getActivityList = async (tab) => {
  try {
    const response = await MyServerHttp.post(apiServe.activityList, {
      category_id: tab,
    });
    activityList.value = response.data.datas.list;
    console.log(activityList, "+++++++++++++++++");
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
// getActivityList(datas.value[0].id);
// console.log(datas, "+++++++++++++++++");

const tabChange = (tab) => {
  // contentDatas.value = ref({});
  getActivityList(datas.value[tab].id);
  // if (tab == "0") {
  //   name.value = ref("股票课程/FStockcourse");
  //   img = require("@/assets/chaojiao/预约报名04.png");
  // } else if (tab == "1") {
  //   name.value = ref("金融专题论坛 /Financialforum");
  //   img = require("@/assets/chaojiao/预约报名01.png");
  // } else if (tab == "2") {
  //   name.value = ref("期货产业论坛/FuturesindustryForum");
  //   img = require("@/assets/chaojiao/预约报名02.png");
  // } else if (tab == "3") {
  //   name.value = ref("期货课程/Futures course");
  //   img = require("@/assets/chaojiao/预约报名03.png");
  // } else if (tab == "4") {
  //   name.value = ref("期权课程 /option course");
  //   img = require("@/assets/chaojiao/预约报名02.png");
  // } else if (tab == "5") {
  //   name.value = ref("线下论坛/Offlineforum");
  //   img = require("@/assets/chaojiao/预约报名01.png");
  // } else if (tab == "6") {
  //   name.value = ref("走访私募 /Visit private equity");
  //   img = require("@/assets/chaojiao/预约报名03.png");
  // }
  // switch (tab) {
  //   case 0:
  //     break;
  //   case 1:
  //     name = "333";
  //     break;
  // }
};
</script>

<style scoped>
.text-center {
  overflow-y: hidden;
}

.carousel-item {
  color: #475669;
  opacity: 0.75;
  margin: 0;
  text-align: center;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  display: flex;
  align-items: center;
  margin: 0;
  text-align: center;
  height: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.container {
  width: 1200px;
  margin: 80px auto 0;
  color: #fff;

  div {
    width: 100%;
  }
  h1 {
    font-size: 40px;
    line-height: 0px;
  }
  span {
    font-size: 16px;
  }
  .line {
    width: 80%;
    height: 1px;
    background: #8d0100;
    margin: 10px auto 30px;
  }
}

/deep/.el-table th.el-table__cell {
  background-color: var(--el-table-header-bg-color);
  background: #910101;
  border-bottom: none;
}
/deep/.el-table tr {
  background-color: var(--el-table-tr-bg-color);
  background: black;
}
/deep/.el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: var(--el-fill-color-lighter);
  /* background: #1c1c1c; */
}
/deep/.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: none;
}

/deep/.el-tabs--card > .el-tabs__header .el-tabs__item {
  border: none;
  /* border-left: 1px solid var(--el-border-color-light); */
  transition: color var(--el-transition-duration)
      var(--el-transition-function-ease-in-out-bezier),
    padding var(--el-transition-duration)
      var(--el-transition-function-ease-in-out-bezier);
  width: 120px;
  color: #fff !important;
}

/deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
  box-sizing: border-box;
  border: none;
  /* background: #f5f6fa; */
  border-radius: 30px;
}
/deep/.el-tabs__nav-next,
.el-tabs__nav-prev {
  color: var(--el-text-color-secondary);
  cursor: pointer;
  font-size: 12px;
  line-height: 44px;
  position: absolute;
  text-align: center;
  width: 0;
  display: none;
}
/deep/.el-tabs__nav-next,
.el-tabs__nav-prev {
  color: var(--el-text-color-secondary);
  cursor: pointer;
  font-size: 12px;
  line-height: 44px;
  position: absolute;
  text-align: center;
  display: none !important;
}
/deep/.el-tabs--card > .el-tabs__header {
  border: none;
  height: var(--el-tabs-header-height);
  padding: 20px;
}

/deep/.el-tabs__item.is-active,
.el-tabs__item:hover {
  /* color: var(--el-color-primary); */
  /* background: rgb(33, 52, 133); */
  /* background-image: url("@/assets/chaojiao/期权.png"); */
  /* border-radius: 30px; */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
}
/deep/.el-tabs__nav-wrap:after {
  background-color: transparent;
}
/deep/.el-tabs__active-bar {
  /* background-color: #535353; */
}
/deep/.el-tabs--left .el-tabs__item.is-left {
  text-align: right;
  display: flex;
  justify-content: center;
  /* padding-left: 40px;   */
  width: 200px;
  align-items: center;
}
/deep/.el-tabs__active-bar {
  background: #535353;
}
/deep/.el-tabs__nav-scroll {
  overflow: hidden;
  background: #fff;
  /* padding: 20px; */
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1), -5px -5px 5px rgba(0, 0, 0, 0.1);
  color: #000;
}

/deep/.el-tabs--left .el-tabs__header.is-left,
.el-tabs--left .el-tabs__header.is-right,
.el-tabs--left .el-tabs__nav-scroll,
.el-tabs--left .el-tabs__nav-wrap.is-left,
.el-tabs--left .el-tabs__nav-wrap.is-right,
.el-tabs--right .el-tabs__header.is-left,
.el-tabs--right .el-tabs__header.is-right,
.el-tabs--right .el-tabs__nav-scroll,
.el-tabs--right .el-tabs__nav-wrap.is-left,
.el-tabs--right .el-tabs__nav-wrap.is-right {
  margin: 0;
  padding: 0;
}
/deep/.el-tabs__item {
  color: #535353;
}

.el-link:hover {
  color: #333;
}

.business-col {
  color: #fff;
  background-image: url("@/assets/chaojiao/期权.png");
  /* background-size: cover; 或者使用 100% 100% */
  /* background-position: center; 确保图片居中 */
  /* backgr
  ound-repeat: no-repeat; 防止图片重复 */
}

.green {
  color: rgb(22, 40, 124);
}
</style>
